import { NgModule } from "@angular/core";
import { PHBHPLocalizePackageModule } from "ph-bhp-feature-packages/ph-bhp-localize-package/public_api";
import { PHBHPLayoutPackageModule } from "ph-bhp-feature-packages/ph-bhp-layout-package/public_api";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { PhBhpViewSopobserveComponent } from "./ph-bhp-view-sopobserve/ph-bhp-view-sopobserve.component";
import { PhBhpObserveCommentsComponent } from "./ph-bhp-observe-comments/ph-bhp-observe-comments.component";
import { PhBhpObserveProtocolCommentsComponent } from "./ph-bhp-observe-protocol-comments/ph-bhp-observe-protocol-comments.component";
import { PhBhpUiModule } from "ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module";
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { PhBhpSopObservePdfExportComponent } from './ph-bhp-sop-observe-pdf-export/ph-bhp-sop-observe-pdf-export.component';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/lib/ph-bhp-feature-components.module';
// common libraries

@NgModule({
    declarations: [PhBhpViewSopobserveComponent, PhBhpObserveCommentsComponent, PhBhpSopObservePdfExportComponent, PhBhpObserveProtocolCommentsComponent],
    imports: [
        PHBHPLocalizePackageModule,
        CollapseModule,
        PHBHPLayoutPackageModule,
        PhBhpUiModule,
        MatIconModule,
        MatSelectModule,
        MatRadioModule,
        MatListModule,
        PDFExportModule,
        PhBhpFeatureComponentsModule
    ],
    exports: [PhBhpViewSopobserveComponent, PhBhpObserveCommentsComponent, PhBhpSopObservePdfExportComponent, PhBhpObserveProtocolCommentsComponent]
})
export class PhBhpFeaturePackageSopobservationModule { }
